import { LinkedObject } from './base';

export type MediabankFileTypeNames = 'Undetermined' | 'Video' | 'Image' | 'Audio' | 'Document';
export type MediabankFileType = { id: number; pattern?: string };

export const MediabankFileTypes: Record<MediabankFileTypeNames, MediabankFileType> = {
	Undetermined: { id: 0 },
	Video: { id: 1, pattern: 'video/mp4' },
	Image: { id: 2, pattern: 'image/*' },
	Audio: { id: 3, pattern: 'audio/*' },
	Document: { id: 4, pattern: 'application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document' },
};

export function getMediabankFileTypeById(id: number): MediabankFileType | undefined {
	const fileType = Object.values(MediabankFileTypes).find((fileType) => fileType.id === id);
	return fileType;
}

export type MediabankSearchParams = {
	top?: number;
	type?: MediabankFileType;
	searchTerm?: string;
	tagId?: number;
	uploadLocations: number[];
	dateFrom?: Date;
	dateTo?: Date;
};

export type MediabankFile = {
	Id: number;
	Name: string;
	Description: string | null;
	FileUrl: string;
	FileSource?: string;
	Settings?: MediabankFileSettings;
	Thumbnail?: string;
	UrlRewrite?: string;
	Type: number;
	UploadLocation?: number;
};

export type MediabankFileSettings = {
	Width?: number;
	Height?: number;
	Proportions?: number;
	FileSizeKB?: number;
	FocusX?: number;
	FocusY?: number;
	ExternalId?: string;
	ExternalAuthorName?: string;
	ExternalAuthorUrl?: string;
};

export type MediabankSettings = {
	folderId?: number | null;
	skipDefaultPermissions?: boolean;
	skipResize?: boolean;
	reuseExistingImage?: boolean;
	linkToObject?: LinkedObject;
	linkToDir?: string;
	isPrivate?: boolean;
	isInvisible?: boolean;
};

export type UnsplashPhoto = {
	id: string;
	urls: {
		full: string;
		raw: string;
		regular: string;
		small: string;
		thumb: string;
	};
	alt_description: string | null;
	description?: string;
	user: {
		name: string;
		links?: {
			html?: string;
		};
	};
	links: {
		download_location: string;
		html?: string;
	};
};

export type OrientationType = 'landscape' | 'portrait' | 'squarish';

export type UnsplashColorType =
	| 'black_and_white'
	| 'black'
	| 'white'
	| 'yellow'
	| 'orange'
	| 'red'
	| 'purple'
	| 'magenta'
	| 'green'
	| 'teal'
	| 'blue';

// 300 | 960 | 1280 | 1920 | * | *
export type MediabankImageSize = 'sm' | 'mobile' | 'pad' | 'desktop' | 'max' | 'raw' | '';

export enum MediabankUploadLocation {
	Undefined = 0,
	MediabankAdmin = 1,
	SpeedquizAdmin = 2,
	CMS = 3,
	OnlineEducation = 4,
	LevelSystem = 5,
	UserProfile = 6,
	Speedquiz = 7,
	Ticket = 8,
	Goal = 9,
	GenericComment = 10,
	FrontEndObject = 11,
	DocumentCategory = 12,
	DocumentEdit = 13,
	EventAdmin = 14,
	Whiteboard = 15,
	Badges = 16,
	TimeReportExpense = 17,
	UserAdmin = 18,
}

export type LinkedMediabankFile = {
	MediaBankFile?: MediabankFile;
	MediaBankFileId: number;
	ObjectId: number;
	ObjectType: string;
};

export type MbfObject = {
	Id: number;
	ImageUrl: string | null;
	Settings: MbfObjectSettings;
};

export type MbfObjectSettings = {
	FocusX: number;
	FocusY: number;
};
